import React from 'react';

// local dependencies
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { samlError as SamlError } from 'ui/views/layouts/samlError';
 *
 * // render
 * <SamlError propName='propValue'/>
 */
export const samlError = () => {
    return (
        <div className='ui-saml-error'>
            <Icon name='somethingWentWrong' width='360' height='200'/>

            <div className='ui-saml-error__message'>Oops. Something Went Wrong!</div>
            <div className='ui-saml-error__code'>Error Code: SAML_ERR</div>
        </div>
    );
};

// set display name
samlError.displayName = 'samlError';

// set default props
samlError.defaultProps = {};

// prop types
samlError.propTypes = {};
